import { useGetSocialThumbnail } from '@/shared/hooks/socialThumbnail'
import { useQuery } from '@tanstack/react-query'
import { useUser } from 'containers/user/hooks/useUser'

export const useImageFormUrl = (url?: string) => {
  const { user } = useUser()
  const { getSocialThumbnail } = useGetSocialThumbnail('highlight', user?.id)
  const { data, isLoading, error, ...rest } = useQuery({
    queryKey: ['thumbnail_from_url', url],
    queryFn: () => getSocialThumbnail(url),
    enabled: false,
    retry: false,
  })

  return { data, isLoading, error, ...rest }
}
